import { render, staticRenderFns } from "./DepartmentsSelection.vue?vue&type=template&id=0af39ebc&scoped=true&"
import script from "./DepartmentsSelection.vue?vue&type=script&lang=js&"
export * from "./DepartmentsSelection.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsSelection.vue?vue&type=style&index=0&id=0af39ebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af39ebc",
  null
  
)

export default component.exports